import HeaderPaddingMain from '@/views/layout/HeaderPaddingMain.vue';
var router = [{
  path: '/teacherImport',
  component: HeaderPaddingMain,
  name: 'teacherImport',
  meta: {
    title: '教师导入',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/teacher/TeacherImport.vue');
    }
  }]
}, {
  path: '/confirmTeacher',
  component: HeaderPaddingMain,
  name: 'confirmTeacher',
  meta: {
    title: '信息确认',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/teacher/ConfirmTeacher.vue');
    }
  }]
}, {
  path: '/batchImportTeacherInfo',
  component: HeaderPaddingMain,
  name: 'batchImportTeacherInfo',
  meta: {
    title: '任教信息批量导入',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/teacher/batchImportTeacherInfo.vue');
    }
  }]
}, {
  path: '/roleSetting',
  component: HeaderPaddingMain,
  name: 'roleSetting',
  meta: {
    title: '角色设置',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/teacher/RoleSetting.vue');
    }
  }]
}];
export default router;